import { ChangeDetectionStrategy, Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { CHECK_BOX_SIZE } from 'src/app/core/models/check-box-size.enum';
import { FONT_SIZE } from 'src/app/core/models/font-size.enum';

@Component({
  selector: 'app-checkbox',
  templateUrl: './app-checkbox.component.html',
  styleUrl: './app-checkbox.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppCheckboxComponent implements ControlValueAccessor {
  private static nextGeneratedId = 0;
  private readonly generatedId = `app-checkbox-${AppCheckboxComponent.nextGeneratedId++}`;

  @Input() label: string | undefined;
  @Input() id: string = '';
  @Input() fontSize: FONT_SIZE = FONT_SIZE.SMALL;
  @Input() size: CHECK_BOX_SIZE = CHECK_BOX_SIZE.SMALL;
  @Input() noPaddingLeft: boolean = false;

  public FONT_SIZE = FONT_SIZE;
  public CHECK_BOX_SIZE = CHECK_BOX_SIZE;

  public get inputId(): string {
    return this.id || this.generatedId;
  }

  get control(): FormControl {
    return this.ngControl?.control as FormControl;
  }

  public onLabelClick(event: MouseEvent): void {
    if (!this.control || this.control.disabled) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    this.control.patchValue(!this.control.value);
    this.control.markAsDirty();
    this.control.markAsTouched();
  }

  constructor(@Self() @Optional() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  onChange: any = (value: boolean) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}
}
